module.exports = __webpack_public_path__ + "media/images/fallback/product_thumb-35bac7863662531b963112679207a139.webp";